module.exports = __webpack_public_path__ + "images/backgrounds/dew/small.37685d6a147f334f7ed9.jpg";